import { useLocalStorage } from "usehooks-ts";
import { en } from "./en";
import { fr } from "./fr";

export const SUPPORTED_LANGUAGES = ["en", "fr"];
export const useTranslation = () => {
  const [locale] = useLocalStorage("vs_locale", "en");
  const keyToTranslationFile = {
    en,
    fr,
  };

  const translate = (key: keyof typeof en): string => {
    if (SUPPORTED_LANGUAGES.includes(locale)) {
      return keyToTranslationFile[locale][key];
    } else {
      return keyToTranslationFile["en"][key];
    }
  };
  return { t: translate };
};
